import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import transformObjectArrayResponse from '../../utils/transformObjectArrayResponse';
import Utils from '../../utils';
import useFeatureFlags from '../../hooks/useFeatureFlags.js';
import store from '../../state/store.js';
import Logger from '../../lib/analytics/logger';
import ERROR_CODE from '../../utils/errorCodes';
import { FE_SNEAK_PEEK } from '../../utils/featureFlags/constants';
import { deleteInboxMessages, postGetInboxMessages } from '../../state/query/message/index.js';
import { EVENT_TYPES } from '../../lib/analytics/constants';
/** @typedef {import('../../api/Constants').InboxMessagesResponse} InboxMessagesResponse */
/** @typedef {import('../../api/Constants').InboxCategory} InboxCategory */
/** @typedef {import('../../api/Constants').InboxMessagePreview} InboxMessagePreview */

var INTERVAL = 60000;
var EventEmitter = require('events');
var InboxMessagesProvider = /*#__PURE__*/function (_EventEmitter) {
  function InboxMessagesProvider() {
    var _this;
    _classCallCheck(this, InboxMessagesProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, InboxMessagesProvider, [].concat(args));
    _this.EVENTKEY = 'INBOX_UPDATE';
    _this.state = {
      count: 0,
      categories: [],
      messages: [],
      timeStamp: null,
      init: false
    };
    _this.resetInbox = function () {
      _this.state = {
        count: 0,
        categories: [],
        messages: [],
        timeStamp: null,
        init: false
      };
    };
    /**
     * Remove a message from the cache
     * @param {Number} id Id for the message
     */
    _this.removeMessage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var removeFromServer,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              removeFromServer = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
              _this.readMessage(id, false);
              if (!removeFromServer) {
                _context.next = 13;
                break;
              }
              _context.prev = 3;
              _context.t0 = removeFromServer;
              if (!_context.t0) {
                _context.next = 8;
                break;
              }
              _context.next = 8;
              return store.dispatch(deleteInboxMessages.initiate(id)).unwrap();
            case 8:
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t1 = _context["catch"](3);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context.t1, Object.getOwnPropertyNames(_context.t1)),
                code: ERROR_CODE.REMOVE_INBOX_MESSAGE_ERROR_CODE
              });
            case 13:
              /** @type {InboxMessagePreview[]} */
              _this.state.messages = _this.state.messages.map( /** @param {InboxMessagePreview} msg */
              function (msg) {
                var newMsg = msg;
                if (newMsg.message_id === id) {
                  newMsg.deleted = true;
                }
                return newMsg;
              });
              _this.state.timeStamp = Date.now() - INTERVAL;
              _this.emit(_this.EVENTKEY);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 10]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * @private
     */
    _this.fetchNewMessages = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _ref3,
        _ref3$providedData,
        providedData,
        _useFeatureFlags,
        hasFeature,
        msgResponse,
        messagesFromResponse,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _ref3 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref3$providedData = _ref3.providedData, providedData = _ref3$providedData === void 0 ? false : _ref3$providedData;
            _useFeatureFlags = useFeatureFlags(), hasFeature = _useFeatureFlags.hasFeature;
            _this.state.init = true;
            _this.state.timeStamp = Date.now();
            _context2.prev = 4;
            if (!providedData) {
              _context2.next = 9;
              break;
            }
            msgResponse = _objectSpread({}, providedData);
            _context2.next = 12;
            break;
          case 9:
            _context2.next = 11;
            return store.dispatch(postGetInboxMessages.initiate({}, {
              forceRefetch: true
            })).unwrap();
          case 11:
            msgResponse = _context2.sent;
          case 12:
            messagesFromResponse = transformObjectArrayResponse(msgResponse.messages).filter(function (msg) {
              return !Utils.isEmpty(msg) && msg.redeemed !== 'yes';
            });
            if (!hasFeature(FE_SNEAK_PEEK)) {
              messagesFromResponse = messagesFromResponse.filter(function (item) {
                return !Utils.isEmpty(item) && item.action && item.action.search('sneakPeek:') === -1 || !Utils.isEmpty(item) && !item.action;
              });
            }
            _this.state.count = messagesFromResponse.filter(function (msg) {
              return !Utils.isEmpty(msg) && msg.message_read !== 'yes';
            }).length;
            /** @type {InboxCategory[]} */
            _this.state.categories = transformObjectArrayResponse(msgResponse.categories);
            /** @type {InboxMessagePreview[]} */
            _this.state.messages = messagesFromResponse.map(function (msg) {
              var newMsg = msg;
              newMsg.deleted = false;
              return newMsg;
            });
            _context2.next = 22;
            break;
          case 19:
            _context2.prev = 19;
            _context2.t0 = _context2["catch"](4);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context2.t0, Object.getOwnPropertyNames(_context2.t0)),
              code: ERROR_CODE.GET_INBOX_MESSAGES_ERROR_CODE
            });
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 19]]);
    }));
    return _this;
  }
  _inherits(InboxMessagesProvider, _EventEmitter);
  return _createClass(InboxMessagesProvider, [{
    key: "getMessageCount",
    value: (
    /**
     * @returns {Number}
     */
    function () {
      var _getMessageCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.checkIfExpired()) {
                _context3.next = 3;
                break;
              }
              _context3.next = 3;
              return this.fetchNewMessages();
            case 3:
              return _context3.abrupt("return", this.state.count);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getMessageCount() {
        return _getMessageCount.apply(this, arguments);
      }
      return getMessageCount;
    }())
  }, {
    key: "getMessages",
    value: (
    /**
     * @returns {InboxMessagePreview[]}
     */
    function () {
      var _getMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.checkIfExpired()) {
                _context4.next = 3;
                break;
              }
              _context4.next = 3;
              return this.fetchNewMessages();
            case 3:
              return _context4.abrupt("return", this.state.messages.concat([]));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getMessages() {
        return _getMessages.apply(this, arguments);
      }
      return getMessages;
    }()
    /**
     * Get a particular message by Id
     * @param {Number} id Id for the message
     */
    )
  }, {
    key: "getMessage",
    value: function getMessage(id) {
      var msg;
      for (var i = 0; i < this.state.messages.length; i++) {
        if (parseInt(this.state.messages[i].message_id) === parseInt(id)) {
          msg = this.state.messages[i];
          break;
        }
      }
      return msg;
    }

    /**
     * Set a message to read status from the cache
     * @param {Number} id Id for the message
     * @param {Boolean} notify Whether or not it should emit an event
     */
  }, {
    key: "readMessage",
    value: function readMessage(id) {
      var notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      /** @type {InboxMessagePreview} */
      var msg = this.getMessage(id);
      if (!Utils.isEmpty(msg) && msg.read_status !== 'yes') {
        msg.read_status = 'yes';
        if (this.state.count > 0) {
          this.state.count--;
        }
        if (notify) this.emit(this.EVENTKEY);
      }
    }
  }, {
    key: "checkIfExpired",
    value:
    /**
     * @private
     * @returns {Boolean}
     */
    function checkIfExpired() {
      return !this.state.init || Date.now() - this.state.timeStamp > INTERVAL // 1 minute
      ;
    }
  }]);
}(EventEmitter);
var inboxMessagesProvider = new InboxMessagesProvider();
export default inboxMessagesProvider;